import { Box, CircularProgress, Modal } from '@mui/material';

import { useStyles } from './useStyles';

export const FormsPageLoader = ({ open }: { open: boolean }) => {
  const styles = useStyles();

  return (
    <Modal open={open}>
      <Box sx={styles.loaderPage}>
        <CircularProgress />
      </Box>
    </Modal>
  );
};
